import {useQuery, useMutation, useQueryClient} from 'react-query'
import {
  fetchClaimFiles,
  fetchSupersedingCycles,
  uploadSupersedingDocuments,
} from '../services/supersedingService'
import {UploadSupersedingFilesParams} from '../types/superseding'

export const useSupersedingCycles = (claimNumber: string) => {
  const {
    data: supersedingCycles = [],
    isLoading,
    error,
    refetch,
    isFetching,
  } = useQuery(['supersedingCycles', claimNumber], () => fetchSupersedingCycles(claimNumber), {
    enabled: !!claimNumber,
    refetchOnWindowFocus: false,
    staleTime: 60000, // Prevent multiple rapid fetches within 1 minute
    onError: (err) => {
      console.error('Error fetching superseding cycles:', err)
    },
  })

  return {
    supersedingCycles,
    isLoading,
    error,
    refetch,
    isFetching,
  }
}

export const useClaimFiles = (claimNumber: string, enabled = true) => {
  const {
    data: claimFiles = [],
    isLoading,
    refetch,
  } = useQuery(['claimFiles', claimNumber], () => fetchClaimFiles(claimNumber), {
    enabled: enabled && !!claimNumber,
    refetchOnWindowFocus: false,
    staleTime: 60000,
    onError: (err) => {
      console.error('Error fetching claim files:', err)
    },
  })

  return {claimFiles, isLoading, refetch}
}

export const useUploadSupersedingDocuments = () => {
  const queryClient = useQueryClient()

  return useMutation((params: UploadSupersedingFilesParams) => uploadSupersedingDocuments(params), {
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['supersedingCycles', variables.claimNumber])
    },
    onError: (error) => {
      console.error('Error uploading superseding files:', error)
    },
  })
}
